<style scoped lang="scss" type="text/scss">
.session-ticket-container {
    padding-right: 0.5rem;

    .placeholder {
        width: calc(100% + 0.5rem);
    }
}
</style>

<template>
    <div class="session-ticket-container">
        <placeholder class="placeholder" v-if="competitions === null || competitions.length === 0">
            未添加赛事
        </placeholder>
        <session-ticket v-for="competition in competitions" :key="competition.id" :name="competition.name"
            :year="competition.year_text" :is-main="competition.main === IS_MAIN" :status="competition.status_text"
            :active="competition.id === currentCompetitionId"
            @click.native="changeCompetition(competition.id, competition.name)">
        </session-ticket>
    </div>
</template>

<script>
import Placeholder from "../../../components/placeholder/index";
import SessionTicket from "./session-ticket";
import { COMPETITION_MAIN_OR_NOT_VALUE_MAP } from "../../../constant/competition-main-or-not";
import _ from "lodash";

export default {
    name: "",
    components: {
        Placeholder,
        SessionTicket,
    },
    created() {
        this.loadCompetitions();
        this.$EventBus.$on("sharecompetitionData", (val) => {
            this.changedata(val);
            // this.$store.commit("competition/updateCompetitions", val);
            // this.changeCompetition(val.id);
            // console.log("查询后传值", val);
            this.competitions = val;
            this.currentCompetitionId = val.id;
        });
    },
    data() {
        return {
            IS_MAIN: COMPETITION_MAIN_OR_NOT_VALUE_MAP.YES,
        };
    },
    computed: {
        competitions: {
            get() {
                return this.$store.state.competition.competitions;
            },
            set(value) {
                // console.log("set", value);
                this.$store.commit("competition/changeCompetitions", value);
                // this.$store.commit("competition/updateCompetitions", value);
            },
        },
        currentCompetitionId: {
            get() {
                return this.$store.state.competition.currentCompetitionId;
            },
            set(val) {
                // console.log("id", val);
                this.$store.commit("competition/updateCurrentCompetitionId", val);
            },
        },
    },
    watch: {
        competitions: {
            immediate: true,
            handler(competitions) {
                // console.log("监听", competitions);
                if (competitions !== null && competitions.length > 0) {
                    this.$store.commit(
                        "competition/updateCurrentCompetitionId",
                        _.get(competitions[0], "id")
                    );
                }
            },
        },
    },
    methods: {
        changedata(val) {
            // console.log("传值", val.id);
            // this.$store.commit("competition/updateCompetitions", val);
            // this.$store.commit("competition/changeCompetitions", val);
            // this.changeCompetition(val.id);
        },
        loadCompetitions() {
            this.$store.dispatch("competition/loadCompetitions").then((res) => {
                // console.log("下拉框数据", this.competitions);
                this.$EventBus.$emit("shareData", this.competitions);
            });
        },
        changeCompetition(id) {
            this.$store.commit("competition/updateCurrentCompetitionId", id);
        },
        sednData() { },
    },
};
</script>
